import { IconButton } from '@chakra-ui/react'
import { useHistory } from 'react-router-dom'
import { Button, Modal } from 'uikit'
import { useDocumentDelete } from './useDocumentDelete'
import { useBoolean } from 'react-use'
import { FaTrash } from 'react-icons/fa'

export const Delete = ({ id }) => {
  const history = useHistory()
  const [isOpen, setOpenModal] = useBoolean(false)
  const { mutate: deleteItem, isPending: isLoadingDeleteItem } = useDocumentDelete()

  const handleDelete = () => {
    deleteItem(id, {
      onSuccess: () => {
        history.goBack()
      },
    })
  }

  return (
    <>
      <IconButton
        colorPalette="red"
        aria-label="Delete"
        borderRadius="full"
        size="sm"
        onClick={() => setOpenModal(true)}
      >
        <FaTrash />
      </IconButton>
      <Modal
        role="alertdialog"
        isOpen={isOpen}
        onClose={() => setOpenModal(false)}
        title="Удаление документа"
        footer={
          <>
            <Button onClick={() => setOpenModal(false)}>Отмена</Button>
            <Button loading={isLoadingDeleteItem} colorPalette="red" ml={3} onClick={handleDelete}>
              Удалить
            </Button>
          </>
        }
      >
        Вы действительно хотите удалить документ?
      </Modal>
    </>
  )
}
